'use strict';

/**
 * Metodo che verifica se il numero e' un intero
 * @param number verifica che l'argomento passato sia un numero intero
 * @returns {boolean}
 */
module.exports = function isInt(number) {
    return !!(typeof number === 'number' && !isNaN(parseInt(number)) && (parseInt(number) === parseFloat(number)));
};
